import { ReactElement } from 'react';

import { PrintTemplateMarkAsFavoriteCommand } from '@dreryk/egabinet-document-template-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import {
   dispatchSnackbarPositiveEvent,
   HeartIcon,
   IconFillColor,
   IconWrapper,
   Tooltip,
} from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../../translations';

const t =
   patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.modal.form.table.columns.actions
      .markAsFavorite;

type ConsentsAndAuthorizationsDocumentsMarkAsFavoriteIconProps = {
   readonly documentId: number;
   readonly onMarkedAsFavorite: VoidFunction;
};

export const ConsentsAndAuthorizationsDocumentsMarkAsFavoriteIcon = (
   props: ConsentsAndAuthorizationsDocumentsMarkAsFavoriteIconProps
): ReactElement => {
   const { executeAsync: markAsFavorite } = useCqrsCommand<void, unknown>(
      () => {
         const command = new PrintTemplateMarkAsFavoriteCommand();
         command.id = props.documentId;
         return command;
      },
      {
         onSuccess: () => {
            props.onMarkedAsFavorite();
            dispatchSnackbarPositiveEvent(t.successMessage);
         },
      }
   );

   return (
      <Tooltip testId={'markAsFavorite'} content={t.tooltipMessage}>
         <IconWrapper onClick={markAsFavorite} testId={'markAsFavorite'} fillColor={IconFillColor.PRIMARY_LIGHTER}>
            <HeartIcon />
         </IconWrapper>
      </Tooltip>
   );
};
